import { create } from "zustand";

type loginStateType =
    | undefined
    | "default" //? Main screen for user logged In OR logged Out //! (VERIFY ALL OF THESE)
    | "register" //? Register screen for user logged Out
    | "forgotPassword" //? Forgot Password screen for user logged Out
    | "deleteAccountConfirm" //? Delete Account Confirm screen for user logged In
    | "confirmAccount" //? Confirm Account screen for user logged Out
    | "checkEmail_ResetPassword" //? Check Email screen for user logged In
    | "checkEmail_UpdateEmail" //? Check Email screen for user logged In
    | "checkEmail_CreateAccount" //? Check Email screen for user logged Out
    | "checkEmail_ForgotPassword" //? Check Email screen for user logged Out
    | "loggedOff_ResetPassword" //? Reset Password screen for user logged Out
    | "updateAccount"; //? Update Account screen for user logged In

export interface userDataType {
    id: string;
    email: string;
    profilePicURL?: string;
    userName?: string;
    providers: string[];
}

interface accountManagementStoreType {
    loginState: loginStateType;
    setLoginState: (state: loginStateType) => void;
    userData: userDataType;
    setUserData: (data: userDataType) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    lastSubmitTime: number;
    setLastSubmitTime: (time: number) => void;
    canSubmit: (cooldownMs: number) => boolean;
}

export interface AccountManagementStoreType {
    loginState: loginStateType;
    setLoginState: (state: loginStateType) => void;
    userData?: userDataType;
    setUserData: (data: userDataType) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    lastSubmitTime: number;
    setLastSubmitTime: (time: number) => void;
    canSubmit: (cooldownMs: number) => boolean;
}

const useAccountManagementStore = create<accountManagementStoreType>(
    (set, get) => ({
        loginState: undefined,
        setLoginState: (state) => set({ loginState: state }),
        // userData: {
        //     email: "",
        //     id: "",
        //     profilePicURL: `https://aupaudybeuztwiwhfdkv.supabase.co/storage/v1/object/public/profilePics/37209eb6-1295-4303-bc7d-427d93986bbd?t=1752591127939`,
        //     providers: [],
        // },
        userData: undefined,
        setUserData: (data) => set({ userData: data }),
        isLoading: false,
        setIsLoading: (loading) => set({ isLoading: loading }),
        lastSubmitTime: 0,
        setLastSubmitTime: (time) => set({ lastSubmitTime: time }),
        canSubmit: (cooldownMs) => {
            const now = Date.now();
            const lastSubmit = get().lastSubmitTime;
            return now - lastSubmit >= cooldownMs;
        },
    })
);

export default useAccountManagementStore;
